import { isEqual } from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import MdaeToast from "../../common_widgets/toast";
import { saveUserTask } from "../../user-task-list/add-user-task";
import {
  quickCompleteTask,
  USER_TASK_POPUP_MODE,
} from "../../user-task-list/component";
import { actions } from "async-ops";
import {
  SET_GRID_COMPLETE_CHECKBOX_CLICKED,
  TOGGLE_COMPLETE_TASK_TOAST,
} from "../../user-task-list/reducers/user-task-list-reducer";
import { completeUserTask } from "../../user-task-card-view/task-card";
import {
  SET_CARD_TASK_DATA,
  TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
} from "../../user-task-card-view/reducers/user-task-card-view-reducer";
import "./index.scss";
interface ICancelUpdatedTaskToast {
  isManagerView?: boolean;
  attachedLevelName?: string;
  isExternalUser?: boolean;
  toggleUserTaskPopup?: any;
  refreshUserTaskListFunction?: any;
  isFromMyTaskDashboardWidget?: any;
  refreshListHandler?: any;
  myTaskRequestObject?: any;
  isVisible:boolean;
}

const CancelUpdatedTaskToast: React.FC<ICancelUpdatedTaskToast> = (props) => {
  const dispatch = useDispatch();
  const [isToastShown, setIsToastShown] = useState(false);
  const isOpenedFromCardView = useSelector(
    (state: any) => state.userTaskListReducer.isOpenedFromCardView,
    isEqual
  );
  const isGridCompleteCheckboxClicked = useSelector(
    (state) => state["userTaskListReducer"].isGridCompleteCheckboxClicked,
    isEqual
  );
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  const userTaskFormDataForCancel = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormDataForCancel,
    isEqual
  );
  const initialTaskData = useSelector(
    (state: any) => state.userTaskListReducer.initialTaskData,
    isEqual
  );
  const currentAttachedLevelId = useSelector(
    (state) => state["userTaskListReducer"].currentAttachedLevelId,
    isEqual
  );
  const currentAttachedLevelName = useSelector(
    (state) => state["userTaskListReducer"].currentAttachedLevelName,
    isEqual
  );
  const userTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskPopupMode,
    isEqual
  );
  const includeNonAttachedLevelTasks = useSelector(
    (state: any) => state["userTaskListReducer"].includeNonAttachedLevelTasks,
    isEqual
  );
  const currentRowTaskData = useSelector(
    (state) => state["userTaskListReducer"].currentRowTaskData,
    isEqual
  );
  const currentCardTaskData = useSelector(
    (state: any) => state["myTaskReducer"].currentCardTaskData,
    isEqual
  );
  const initialCardTaskData = useSelector(
    (state) => state["myTaskReducer"].initialCardTaskData,
    isEqual
  );
  const isMaintenanceLevelTask = useSelector(
    (state: any) => state.userTaskListReducer.isMaintenanceLevelTask,
    isEqual
  );
  let userLevelNameList = useSelector(
    (state) => state["userTaskListReducer"].userLevelNameList,
    isEqual
  );
  if (userLevelNameList && userLevelNameList.length > 0) {
    if (
      props.attachedLevelName?.toUpperCase() === "EA" &&
      userTaskFormData?.level?.toUpperCase() === "EAC" &&
      userTaskPopupMode == USER_TASK_POPUP_MODE.ADD
    ) {
      const isAllExists =
        userLevelNameList.filter((x) => x.attachedLevelId === -1).length > 0;
      if (!isAllExists) {
        userLevelNameList.unshift({
          attachedLevelId: -1,
          attachedLevelTitle: "Add tasks to all cases in round",
        });
      }
    } else {
      userLevelNameList = userLevelNameList.filter(
        (x) => x.attachedLevelId > 0
      );
    }
  }
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );

  return (
    <MdaeToast
      visible={props.isVisible}
      type={"custom"}
      displayTime={10000}
      hideOnOutsideClick={false}
      closeOnSwipe={false}
      contentRender={(e) => {
        return (
          <div>
            <span>
              {isMaintenanceLevelTask && (
                <span>Task has been marked complete.&nbsp;</span>
              )}
              {!isMaintenanceLevelTask && (
                <span>
                  Task has been marked complete and will be returned to the
                  auditor (if internal) or audit/case process manager (if external).&nbsp;
                </span>
              )}
              <a
                className={"cancel-update-task"}
                onClick={() => {
                  if (!isOpenedFromCardView) {
                    dispatch({
                      type: TOGGLE_COMPLETE_TASK_TOAST,
                      data: {
                        isCompleteTaskToastVisible: false,
                      },
                    });
                    if (!isGridCompleteCheckboxClicked) {
                      userTaskFormDataForCancel.statusId = initialTaskData.statusId;
                      userTaskFormDataForCancel.assignedToUserId =
                        initialTaskData.assignedToUserId;
                        userTaskFormDataForCancel.completeInd = false;
                        userTaskFormDataForCancel.completionDate = null;
                        userTaskFormDataForCancel.completedByUsedId = null;
                        userTaskFormDataForCancel.notificationId =
                        initialTaskData.notificationId;
                        userTaskFormDataForCancel.newUserTasksCreatedIds =
                        initialTaskData.newUserTasksCreatedIds;
                        userTaskFormDataForCancel.assignedUserType =
                        initialTaskData.assignedUserType;
                      let properties = {
                        toggleUserTaskPopup: props.toggleUserTaskPopup,
                        userTaskPopupMode: USER_TASK_POPUP_MODE.EDIT,
                        isManagerView: true,
                        isFromUserTaskList: true,
                        refreshUserTaskListFunction:
                          props.refreshUserTaskListFunction,
                        isExternalUser: props.isExternalUser,
                        isFromMyTaskPage: false,
                      };
                      saveUserTask(
                        true,
                        userTaskFormDataForCancel,
                        currentAttachedLevelId,
                        currentAttachedLevelName,
                        userTaskPopupMode,
                        userLevelNameList,
                        dispatch,
                        asyncAction,
                        properties,
                        includeNonAttachedLevelTasks,
                        initialTaskData,
                        false,
                        true
                      );
                    } else {
                      quickCompleteTask(
                        dispatch,
                        currentRowTaskData,
                        props.refreshUserTaskListFunction,
                        props.isManagerView,
                        currentAttachedLevelId,
                        currentAttachedLevelName,
                        props.isExternalUser,
                        initialTaskData,
                        true
                      );
                      dispatch({
                        type: SET_GRID_COMPLETE_CHECKBOX_CLICKED,
                        data: {
                          isGridCompleteCheckboxClicked: false,
                          currentRowTaskData: {},
                        },
                      });
                    }
                  } else {
                    dispatch({
                      type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
                      data: {
                        isCompleteTaskToastVisibleForCardView: false,
                      },
                    });
                    completeUserTask(
                      currentCardTaskData?.userTaskId > 0
                        ? currentCardTaskData
                        : userTaskFormData,
                      currentCardTaskData?.userTaskId > 0
                        ? initialCardTaskData
                        : initialTaskData,
                      dispatch,
                      true,
                      props.isFromMyTaskDashboardWidget,
                      props.refreshListHandler,
                      props.myTaskRequestObject,
                      true
                    );
                    dispatch({
                      type: SET_CARD_TASK_DATA,
                      data: {
                        currentCardTaskData: {},
                      },
                    });
                  }
                }}
              >
                Click here to cancel
              </a>
            </span>
          </div>
        );
      }}
      onShowing={(e) => {
        setIsToastShown(true);
      }}
      onHiding={(e) => {
        if (isToastShown) {
          setIsToastShown(false);
          if (!isOpenedFromCardView) {
            dispatch({
              type: TOGGLE_COMPLETE_TASK_TOAST,
              data: {
                isCompleteTaskToastVisible: false,
              },
            });
            dispatch({
              type: SET_GRID_COMPLETE_CHECKBOX_CLICKED,
              data: {
                isGridCompleteCheckboxClicked: false,
                currentRowTaskData: {},
              },
            });
          } else {
            dispatch({
              type: TOGGLE_COMPLETE_TASK_TOAST_FOR_CARD_VIEW,
              data: {
                isCompleteTaskToastVisibleForCardView: false,
              },
            });
            dispatch({
              type: SET_CARD_TASK_DATA,
              data: {
                currentCardTaskData: {},
              },
            });
          }
        } else {
          e.cancel = true;
        }
      }}
    ></MdaeToast>
  );
};

export default CancelUpdatedTaskToast;
